// eslint-disable-next-line import/prefer-default-export
export const getSelectedOrgId = (agentId: number, orgId: number) => `${agentId}-pro-selected-org-${orgId}`;
